const BASE = 'https://solana-hub-production.up.railway.app/api';

const request = async (method, path, body = null) => {
  const token = localStorage.getItem('token');
  const opts = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, opts);
  const data = await res.json();
  if (!res.ok) {
    if (res.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.reload();
    }
    const msg = data?.errors?.[0]?.msg || data?.error || 'Request failed';
    throw new Error(msg);
  }
  return data;
};

export const api = {
  // Auth
  register:          (body)      => request('POST',   '/auth/register', body),
  login:             (body)      => request('POST',   '/auth/login', body),
  getMe:             ()          => request('GET',    '/auth/me'),
  updateTelegram:    (body)      => request('PUT',    '/auth/telegram', body),
  updatePassword:    (body)      => request('PUT',    '/auth/password', body),

  // Wallets
  getWallets:        ()          => request('GET',    '/wallets'),
  addWallet:         (body)      => request('POST',   '/wallets', body),
  removeWallet:      (address)   => request('DELETE', `/wallets/${address}`),
  getWalletActivity: (addr, q)   => request('GET',    `/wallets/${addr}/activity?${new URLSearchParams(q||{})}`),
  getListenerStatus: ()          => request('GET',    '/wallets/status'),

  // Rules
  getRules:          ()          => request('GET',    '/rules'),
  createRule:        (body)      => request('POST',   '/rules', body),
  updateRule:        (id, body)  => request('PUT',    `/rules/${id}`, body),
  deleteRule:        (id)        => request('DELETE', `/rules/${id}`),
  testRule:          (id)        => request('POST',   `/rules/${id}/test`),

  // Activity
  getActivity:       (q)         => request('GET',    `/activity?${new URLSearchParams(q||{})}`),
  getStats:          ()          => request('GET',    '/activity/stats'),

  // Health
  health:            ()          => request('GET',    '/health'),
};
